import { BlogPost } from '../types';

const post: BlogPost = {
	slug: 'kayfa-tasnaa-kitab-qisas-mukhassas-litiflik',
	title: 'كيف تصنع كتاب قصص مخصصاً يكون فيه طفلك هو البطل',
	description:
		'دليل خطوة بخطوة لصنع كتاب قصص مخصص: اختيار الصورة، اختيار أسلوب الرسم، ضبط التشابه بدقة، وما يجب التحقق منه قبل الموافقة على الطباعة.',
	date: '2026-02-03',
	heroImage: '/assets/hero/kid-3/watercolor_scene.png',
	tags: ['إرشادات', 'كتب مخصصة'],
	body: `صنع كتاب قصص مخصص أمر بسيط في معظمه. الأجزاء التي تسوء متوقعة، وتعود جميعها تقريباً إلى الصورة المستخدمة.

هذه هي العملية كاملة، وما يجب الانتباه له في كل مرحلة.

## 1. اختر القصة أولاً، لا أسلوب الرسم

القصة هي التي تحدد النبرة العامة. مغامرة ليلية تختلف عن مهمة إنقاذ تحت الماء وتناسب أطفالاً مختلفين، ويجب أن يتبع أسلوب الرسم القصة، لا العكس.

إذا كنتم تشترون لطفل دون الرابعة، فضّلوا القصص الأقصر بمشاهد أبسط. حوالي اثنتي عشرة صفحة مرسومة هي النقطة المثالية — طويلة بما يكفي لتحتوي على بداية ونهاية، وقصيرة بما يكفي لتُقرأ وقت النوم دون تفاوض.

## 2. اختر الصورة بعناية

هذه هي الخطوة التي تحدد كل شيء بعدها. الصورة الجيدة تنتج شخصية تشبه طفلكم بشكل لا لبس فيه؛ والصورة السيئة تنتج شخصية تشبه ابن العم أكثر.

**ما ينجح:**

- وجه أمامي، أو قريب من ذلك
- إضاءة متساوية وناعمة — قرب النافذة مثالي
- الوجه بأكمله ظاهر وواضح التركيز
- تعبير محايد أو ابتسامة خفيفة

**ما يسبب مشاكل:**

- القبعات أو النظارات الشمسية أو الشعر الذي يغطي الوجه
- الظلال القوية، خصوصاً من شمس علوية مباشرة
- الزوايا الحادة — النظر إلى الأعلى أو الأسفل بشكل حاد
- الفلاتر الثقيلة، أو تنعيم البشرة، أو صور الهاتف في إضاءة منخفضة مع تقليل ضوضاء مبالغ فيه
- الصور الجماعية التي يكون فيها وجه الطفل صغيراً داخل الإطار

لستم بحاجة إلى صورة احترافية. صورة بالهاتف تُلتقط داخل المنزل في يوم غائم عادة ما تكون أفضل من صورة خارجية مشرقة، لأن الإضاءة فيها أكثر تجانساً.

## 3. اختر أسلوب الرسم

كل أسلوب يغيّر طريقة ظهور التشابه:

- **ألوان مائية** — ناعم، تقليدي، أقرب إلى التذكار. جميل، لكن التشابه انطباعي أكثر منه دقيقاً.
- **كتاب قصص كلاسيكي** — دافئ ومفصّل، الأقرب إلى الكتب المصورة التي يتذكرها معظم البالغين.
- **مسطّح حديث** — أشكال جريئة وألوان قوية. الأنسب للأطفال الصغار جداً.
- **كوميكس** — بلوحات متتابعة وحيوية. يناسب الأطفال الأكبر سناً.
- **ثلاثي الأبعاد بأسلوب بيكسار** — لامع ومُصمَّم بدقة عالية. عادة ما يكون الأكثر تشابهاً يمكن التعرف عليه فوراً، وهو الأسلوب الذي يختاره الأطفال عند تخييرهم.

إذا كان الكتاب هدية للطفل أساساً، اختاروا الأسلوب الأوضح تشابهاً. أما إذا كان تذكاراً لكم أنتم بالدرجة الأولى، فالألوان المائية والأسلوب الكلاسيكي يتقادمان بشكل أجمل.

## 4. تحقق من الشخصية قبل بناء الكتاب

تُولَّد الشخصية أولاً، قبل المشاهد الفردية. هذه هي أرخص نقطة يمكن فيها اكتشاف أي مشكلة.

انظروا إليها واسألوا سؤالاً واحداً: *هل سيتعرف الجد أو الجدة على هذا الطفل؟*

إذا كانت الإجابة لا، جرّبوا صورة مختلفة قبل المتابعة. تصحيح الشخصية الآن أسرع بكثير من مراجعة اثنتي عشرة صفحة مبنية على تشابه لم يكن صحيحاً من البداية.

## 5. راجع كل صفحة

بعد توليد المشاهد، اطّلعوا عليها بعناية حقيقية لا بنظرة سريعة.

أمور تستحق التحقق منها:

- **الاتساق.** هل تبدو الشخصية وكأنها الطفل نفسه في كل مشهد؟ الأطفال يلاحظون عدم الاتساق أسرع من البالغين، وهذا يكسر الوهم فوراً.
- **الأيدي والتفاصيل الصغيرة.** هذه هي النقطة التي تاريخياً تعاني منها الرسوم المولَّدة أكثر من غيرها.
- **موضع النص.** تأكدوا من أن لا شيء مهم في الرسمة محجوب.
- **الغلاف.** إنه الصفحة التي يُنظر إليها أكثر من غيرها.

أي صفحة غير صحيحة يمكن إعادة توليدها. افعلوا هذا قبل الموافقة — لا شيء يُطبع قبل أن توافقوا، وهذا بالضبط سبب وجود هذه الخطوة.

## 6. الموافقة والطباعة

بعد الموافقة، يذهب الكتاب إلى الطباعة ثم الشحن. احسبوا وقتاً كافياً: أسبوعان إلى ثلاثة أسابيع من الطلب إلى الوصول افتراض تخطيطي مريح، وأكثر من ذلك في شهر ديسمبر.

## ملاحظة حول اللغات

إذا كنتم تُنتجون الكتاب بلغة تُكتب من اليمين إلى اليسار مثل العربية، فيجب أن يكون التخطيط معكوساً بالفعل — ترتيب الصفحات، ومحاذاة النص، وموضع الرسوم — وليس مجرد ترجمة النص داخل قالب مصمم من اليسار إلى اليمين. الكتاب المكتوب من اليمين إلى اليسار لكن مرقّم الصفحات من اليسار إلى اليمين يُقرأ بترتيب معكوس، وهو أمر واضح فوراً لأي قارئ يتحدث العربية بشكل أصلي، لكنه سهل الإغفال إن لم تكن كذلك.

## أخطاء شائعة، باختصار

1. اختيار الصورة الأجمل بدلاً من الأوضح. غالباً ما تكون الصورة الأجمل مُلتقطة بإضاءة خلفية عند الغروب. وهذه أسوأ حالة ممكنة.
2. الموافقة دون النظر إلى كل صفحة.
3. الطلب قبل أربعة أيام فقط من عيد الميلاد.
4. اختيار الألوان المائية لطفل عمره سنتان لأن البالغ هو من يفضّلها.

لا شيء من هذه الأخطاء قاتل، لكن جميعها يمكن تجنبه.`,
	faqs: [
		{
			question: 'ما نوع الصورة الأفضل لكتاب قصص مخصص؟',
			answer:
				'صورة واضحة، أمامية الوجه، بإضاءة متساوية وناعمة، يكون فيها الوجه بأكمله ظاهراً وواضح التركيز. الإضاءة الداخلية قرب نافذة عادة ما تعطي نتيجة أفضل من شمس خارجية ساطعة، التي تُنتج ظلالاً قوية. تجنبوا القبعات والنظارات الشمسية والزوايا الحادة والفلاتر الثقيلة.',
		},
		{
			question: 'هل يمكنني تعديل الرسوم قبل طباعة الكتاب؟',
			answer:
				'نعم. تُولَّد الشخصية أولاً حتى تتمكنوا من التحقق من التشابه مبكراً، وتُراجَع كل صفحة قبل الطباعة. يمكن إعادة توليد أي صفحة فردية إذا لم تكن صحيحة.',
		},
		{
			question: 'كم يجب أن يكون طول كتاب القصص المخصص؟',
			answer:
				'حوالي اثنتي عشرة صفحة مرسومة يناسب معظم الأطفال دون الثامنة — طويل بما يكفي لقصة كاملة، وقصير بما يكفي لقراءته وقت النوم في جلسة واحدة.',
		},
		{
			question: 'أي أسلوب رسم يعطي أفضل تشابه؟',
			answer:
				'الأسلوب الثلاثي الأبعاد بطراز بيكسار والرسم المسطّح الحديث يعطيان عادة التشابه الأكثر وضوحاً وقابلية للتعرف الفوري. أما الألوان المائية والأسلوب الكلاسيكي فهما أكثر نعومة وطابعاً انطباعياً، وهو ما يفضّله كثير من الآباء للتذكارات.',
		},
	],
	lang: 'ar',
	dateLocale: 'ar-EG',
	ui: {
		homeLabel: 'الرئيسية',
		blogLabel: 'المدونة',
		faqHeading: 'الأسئلة الشائعة',
		moreReadingHeading: 'مقالات أخرى',
		ctaLabel: 'تصفح الهدايا المخصصة',
	},
};

export default post;
